import { faDownLong, faSort, faUpLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo, useMemo } from 'react';
import type { JSX } from 'react';

import { Props } from '@/components/Sort/types';
import Select from '@/ui/components/Form/Select';

const Sort = (props: Props): JSX.Element => {
  const { ascending, onChange, onDirectionChange, sortOptions, value } = props;

  const selectedValue = useMemo(() => {
    return (
      sortOptions.find((option) => option.value === value) || {
        label: '',
        value: ''
      }
    );
  }, [sortOptions, value]);

  return (
    <div className="flex items-center">
      {!onDirectionChange && <FontAwesomeIcon className="mr-1" icon={faSort} />}
      <Select
        inline
        label="Sort"
        onChange={onChange}
        options={sortOptions}
        placeholder="Select sort"
        selectedOption={selectedValue}
      />
      {onDirectionChange && (
        <FontAwesomeIcon
          aria-label="Change sort direction"
          className="cursor-pointer"
          icon={ascending ? faUpLong : faDownLong}
          role="button"
          size="lg"
          onClick={onDirectionChange}
        />
      )}
    </div>
  );
};

export default memo(Sort);
